module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-1@3x-2e77a83b2a6b8c70ab728d5aeabd7d12.webp";